import { Formik, Form, ErrorMessage } from 'formik';
import * as yup from 'yup';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { DataSource } from 'components/DataSource';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Title } from 'components/Title';
import useApp from 'hooks/useApp';

import useAddPage from 'hooks/useAddPage';
const WallettransactionAddPage = (props) => {
		const app = useApp();
	
	//form validation rules
	const validationSchema = yup.object().shape({
		trandate: yup.string().required().label("Trandate"),
		userid: yup.string().required().label("Userid"),
		deposit: yup.number().required().label("Deposit"),
		commission: yup.number().required().label("Commission"),
		bookingid: yup.string().nullable().label("Bookingid"),
		remarks: yup.string().nullable().label("Remarks")
	});
	
	//form default values
	const formDefaultValues = {
		trandate: new Date(), 
		userid: '', 
		deposit: "((0))", 
		commission: "((0))", 
		bookingid: '', 
		remarks: '', 
	}
	
	//page hook where logics resides
	const pageController =  useAddPage({ props, formDefaultValues, afterSubmit });
	
	// destructure and grab what the page needs
	const { formData, resetForm, handleSubmit, submitForm, pageReady, loading, saving, inputClassName } = pageController;
	
	//event raised after form submit
	function afterSubmit(response){
		app.flashMsg(props.msgTitle, props.msgAfterSave);
		resetForm();
		if(app.isDialogOpen()){
			app.closeDialogs(); // if page is open as dialog, close dialog
		}
		else if(props.redirect) {
			app.navigate(`/wallettransaction`);
		}
	}
	
	// page loading form data from api
	if(loading){
		return (
			<div className="p-3 text-center">
				<ProgressSpinner style={{width:'50px', height:'50px'}} />
			</div>
		);
	}
	
	//page has loaded any required data and ready to render
	if(pageReady){
		return (
<main id="WallettransactionAddPage" className="main-page">
    { (props.showHeader) && 
    <section className="page-section mb-3" >
        <div className="container">
            <div className="grid justify-content-between align-items-center">
                { !props.isSubPage && 
                <div className="col-fixed " >
                    <Button onClick={() => app.navigate(-1)} label=""  className="p-button p-button-text " icon="pi pi-arrow-left"  />
                </div>
                }
                <div className="col " >
                    <Title title="Add New Wallettransaction"   titleClass="text-2xl text-primary font-bold" subTitleClass="text-500"      separator={false} />
                </div>
            </div>
        </div>
    </section>
    }
    <section className="page-section " >
        <div className="container">
            <div className="grid ">
                <div className="md:col-9 sm:col-12 comp-grid" >
                    <div >
                        <Formik initialValues={formData} validationSchema={validationSchema} onSubmit={(values, actions) =>submitForm(values)}>
                            {(formik) => 
                            <>
                            <Form className={`${!props.isSubPage ? 'card  ' : ''}`}>
                                <div className="grid">
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Trandate *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <Calendar name="trandate" showButtonBar className={inputClassName(formik?.errors?.trandate)} dateFormat="yy-mm-dd" value={formik.values.trandate} onChange={formik.handleChange} showIcon        />
                                                <ErrorMessage name="trandate" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Userid *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <DataSource   apiPath="components_data/verifiedby_option_list"  >
                                                    {
                                                    ({ response }) => 
                                                    <>
                                                    <Dropdown  name="userid"     optionLabel="label" optionValue="value" value={formik.values.userid} onChange={formik.handleChange} options={response} label="Userid"  placeholder="Select a value ..."  className={inputClassName(formik?.errors?.userid)}   />
                                                    <ErrorMessage name="userid" component="span" className="p-error" />
                                                    </>
                                                    }
                                                </DataSource>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Deposit *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="deposit"  onChange={formik.handleChange}  value={formik.values.deposit}   label="Deposit" type="number" placeholder="Enter Deposit"  min={0}  step={0.1}    className={inputClassName(formik?.errors?.deposit)} />
                                                <ErrorMessage name="deposit" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Commission *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="commission"  onChange={formik.handleChange}  value={formik.values.commission}   label="Commission" type="number" placeholder="Enter Commission"  min={0}  step={0.1}    className={inputClassName(formik?.errors?.commission)} />
                                                <ErrorMessage name="commission" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Bookingid 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <DataSource   apiPath="components_data/bookingid_option_list_2"  >
                                                    {
                                                    ({ response }) => 
                                                    <>
                                                    <Dropdown  name="bookingid"     optionLabel="label" optionValue="value" value={formik.values.bookingid} onChange={formik.handleChange} options={response} label="Bookingid"  placeholder="Select a value ..."  className={inputClassName(formik?.errors?.bookingid)}   />
                                                    <ErrorMessage name="bookingid" component="span" className="p-error" />
                                                    </>
                                                    }
                                                </DataSource>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Remarks 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="remarks"  onChange={formik.handleChange}  value={formik.values.remarks}   label="Remarks" type="text" placeholder="Enter Remarks"        className={inputClassName(formik?.errors?.remarks)} />
                                                <ErrorMessage name="remarks" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                { props.showFooter && 
                                <div className="text-center my-3">
                                    <Button onClick={(e) => handleSubmit(e, formik)} className="p-button-primary" type="submit" label="Submit" icon="pi pi-send" loading={saving} />
                                </div>
                                }
                            </Form>
                            </>
                            }
                            </Formik>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </main>
		);
	}
}

//page props and default values
WallettransactionAddPage.defaultProps = {
	primaryKey: 'tranid',
	pageName: 'wallettransaction',
	apiPath: 'wallettransaction/add',
	routeName: 'wallettransactionadd',
	submitButtonLabel: "Submit",
	formValidationError: "Form is invalid",
	formValidationMsg: "Please complete the form",
	msgTitle: "Create Record",
	msgAfterSave: "Record added successfully",
	msgBeforeSave: "",
	showHeader: true,
	showFooter: true,
	redirect: true,
	isSubPage: false
}
export default WallettransactionAddPage;
